import axios from "axios";
import { useCart } from "../Components/cart-context";
import { useNavigate } from "react-router-dom";
export function CartLayout({ className, onClose, branchToken }) {
  const { items, clearCart } = useCart();
  const navigate = useNavigate();

  function handleOrder() {
    const order = {
      branchId: 6,
      payment_status: "paid",
      orderId: 1,
      total_price: items.reduce((acc, item) => {
        return (acc += item.price * item.quantity);
      }, 0),
      items_sold: items,
      b_token: branchToken,
      tt: localStorage.getItem("tt"),
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}/create-order`, {
        data: order,
      })
      .then((res) => {
        clearCart();
        onClose();
        navigate("/history");
      })
      .catch((err) => {
        alert(err);
      });
    //console.log(order);
  }

  return (
    <>
      <div className={`cart-wrapper ${className}`} onClick={onClose}>
        <section onClick={(e) => e.stopPropagation()}>
          <button className="s-btn cart-close-btn" onClick={onClose}>
            <img src="/images/39.webp" alt="" />
          </button>
          <section>
            {items.map((item, idx) => {
              return <CartItem item={item} key={idx} onClose={onClose} />;
            })}
          </section>
          <div className="total-price-view">
            <section>
              <h3>Total Price:</h3>
              <h3 data="price">
                {items.reduce(
                  (sum, item) => sum + item.price * item.quantity,
                  0,
                )}
              </h3>
            </section>
            <button className="p-btn confirm-btn" onClick={handleOrder}>
              <img src="/images/24.webp" alt="" />
              Confirm & Pay
            </button>
          </div>
        </section>
      </div>
    </>
  );
}

function CartItem({ item, onClose }) {
  const { items, removeItem } = useCart();
  return (
    <div className="card rounded">
      <div className="card-content">
        <p name="item_name" className="card-title">
          {item.name}
        </p>
      </div>
      <div className="card-interact-btns">
        <span>{item.quantity}</span>
        <button
          className="del-btn rounded"
          onClick={() => {
            removeItem(item.id);
            console.log(items.length);
            if (items.length === 1) {
              onClose();
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            fill="currentColor"
            viewBox="0 -2 16 19"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z" />
          </svg>
        </button>
      </div>
      <div className="card-price">
        <p name="item_price" value="">
          {item.product_price}
        </p>
      </div>
    </div>
  );
}
